import * as React from "react";

export function CellSkeleton({ width = 80 }: { width?: number }) {
    return (
        <div
            className="h-5 animate-pulse rounded-md bg-gray-100"
            style={{ width }}
        />
    );
}
